import { AbstractNetworkService } from 'core/data/remote/AbstractNetworkService';
import { ResponseResult } from 'core/models/ResponseResult';
export class NetWorkService implements AbstractNetworkService {
  get(endPoint: string): Promise<ResponseResult> {
    return this.perfomRequest(endPoint, 'GET');
  }
  post(endPoint: string): Promise<ResponseResult> {
    return this.perfomRequest(endPoint, 'POST');
  }
  put(endPoint: string): Promise<ResponseResult> {
    return this.perfomRequest(endPoint, 'PUT');
  }
  patch(endPoint: string): Promise<ResponseResult> {
    return this.perfomRequest(endPoint, 'PATCH');
  }
  delete(endPoint: string): Promise<ResponseResult> {
    return this.perfomRequest(endPoint, 'DELETE');
  }

  async perfomRequest(endPoint: string, method: string, header?: Map<string, any>): Promise<ResponseResult> {
    try {
      const response = await fetch(process.env.REACT_APP_SUPABASE_URL + endPoint, {
        method: method,
        headers: {
          apikey: process.env.REACT_APP_SUPABASE_ANON_KEY as string,
          Accept: 'application/json',
        },
      });
      return new ResponseResult({
        code: response.status.toString(),
        timeStamp: new Date().toISOString(),
        success: response.ok,
        message: response.statusText,
        data: await response.json(),
      });
    } catch (error) {
      return new ResponseResult({
        code: '0',
        timeStamp: new Date().toISOString(),
        success: false,
        message: 'Unknown Error - An undefined error occured',
        data: null,
      });
    }
  }
}
